import { render, staticRenderFns } from "./civilization.vue?vue&type=template&id=bdecd6b6&scoped=true&"
import script from "./civilization.vue?vue&type=script&lang=js&"
export * from "./civilization.vue?vue&type=script&lang=js&"
import style0 from "./civilization.vue?vue&type=style&index=0&id=bdecd6b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdecd6b6",
  null
  
)

export default component.exports